export const defaultTransition = {
    ease: "easeInOut",
    duration: 0.3,
};
